import React from 'react'
import withStyles from '@mui/styles/withStyles'
import { Card, Grid } from '@mui/material'
import DarkModeColorCoder from '../../smallComponents/DarkModeColorCoder'

const styles = () => ({
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '90%',
    justifyContent: 'center',
    borderRadius: '20px !important',
    margin: 5,
    ' &:hover': {
      filter: 'brightness(130%)',
    },
  },
  bottomIcon: {
    cursor: 'pointer',
    marginLeft: 5,
    marginRight: 5,
    color: '#333333',
  },
  counterValue: {
    fontSize: 15,
    cursor: 'pointer',
    fontWeight: 550,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: '#333333',
  },
  iconWrapper: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const PBCardsModel = ({
  classes,
  buttonsArray,
  isDarkModeActive,
  hideBottom,
}) => {
  return buttonsArray.map((button, buttonIndex) => (
    <Grid
      item
      xs={12 / buttonsArray.length}
      key={buttonIndex}
      style={{
        width: '100%',
        display: hideBottom ? 'none' : 'flex',
        justifyContent: 'center',
      }}
    >
      <Card
        className={classes.buttonWrapper}
        sx={{
          outline: isDarkModeActive
            ? 'rgb(10, 56, 182)61, 255,) solid 1px'
            : 'none',
          backgroundColor: isDarkModeActive
            ? DarkModeColorCoder('Grey_light')
            : null,
        }}
        onClick={() => {
          if (typeof button.openFun === 'function') button.openFun()
        }}
      >
        <span
          className={classes.iconWrapper}
          style={{
            color: isDarkModeActive && DarkModeColorCoder('Text_white'),
          }}
        >
          {button.icon}
          {button.icon_text}
        </span>
      </Card>
    </Grid>
  ))
}

const WrappedPBCardsModel = withStyles(styles)(PBCardsModel)

export default WrappedPBCardsModel
